import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleWhatIs from "../pages/article-what-is-superbuy-spreadsheet/page";
import ArticleHowToUse from "../pages/article-how-to-use-superbuy-spreadsheet/page";
import ArticleSneakers from "../pages/article-best-superbuy-spreadsheet-sneakers/page";
import ArticleHoodies from "../pages/article-best-superbuy-spreadsheet-hoodies/page";
import ArticleSafety from "../pages/article-how-safe-is-superbuy/page";
import ArticleVs from "../pages/article-superbuy-vs-pandabuy/page";
import ArticleBudget from "../pages/article-best-budget-finds-superbuy/page";
import ArticleYupoo from "../pages/article-buy-from-yupoo-superbuy/page";
import ArticleTopFinds from "../pages/article-top-superbuy-finds/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-superbuy-spreadsheet",
    element: <ArticleWhatIs />,
  },
  {
    path: "/how-to-use-superbuy-spreadsheet",
    element: <ArticleHowToUse />,
  },
  {
    path: "/best-superbuy-spreadsheet-sneakers",
    element: <ArticleSneakers />,
  },
  {
    path: "/best-superbuy-spreadsheet-hoodies",
    element: <ArticleHoodies />,
  },
  {
    path: "/how-safe-is-superbuy",
    element: <ArticleSafety />,
  },
  {
    path: "/superbuy-vs-pandabuy",
    element: <ArticleVs />,
  },
  {
    path: "/best-budget-finds-superbuy",
    element: <ArticleBudget />,
  },
  {
    path: "/buy-from-yupoo-superbuy",
    element: <ArticleYupoo />,
  },
  {
    path: "/top-superbuy-finds",
    element: <ArticleTopFinds />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;